// Track only a native form attempt followed by Shoporama's creation marker.
// A visit to the public thank-you page is never a registration signal.
;(() => {
  if (window.kabookiNativeClubTrackingInitialised) return
  window.kabookiNativeClubTrackingInitialised = true
  const useGoogleCompletion = window.location.hostname === 'kabooki.de'
  const containerId = { 'kabooki.com': 'GTM-KNTXCGM7', 'kabooki.dk': 'GTM-MVBRH9HS', 'kabooki.de': 'GTM-P9DZN2PN' }[window.location.hostname]
  const routeReady = () => Boolean(containerId) &&
    (window.location.hostname === 'kabooki.com' || window.__kbClubRouteReady === true)
  let revoked = false
  const key = 'kabooki:club:pending-native-signup'
  const confirmedKey = 'kabooki:club:confirmed-native-signup'
  const allowed = () => window.Cookiebot?.consent?.statistics === true &&
    window.Cookiebot?.consent?.marketing === true
  const forget = () => { try { window.sessionStorage.removeItem(key) } catch (_) {} }
  const read = () => {
    try { return JSON.parse(window.sessionStorage.getItem(key)) } catch (_) { return null }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target
    if (event.defaultPrevented || !form.matches?.('.user-area__signup-form') ||
        form.matches('.user-area__signup-form--popup')) return
    forget()
    if (!routeReady() || !allowed() ||
        !window.crypto?.randomUUID) return
    const target = new URL(form.action, window.location.href)
    if (target.origin !== window.location.origin || target.pathname !== '/user-sign-up') return
    try {
      window.sessionStorage.setItem(key, JSON.stringify({
        id: window.crypto.randomUUID(), started: Date.now()
      }))
    } catch (_) { /* Without a durable attempt marker, skip tracking. */ }
  })
  const forgetConfirmed = () => { try { window.sessionStorage.removeItem(confirmedKey) } catch (_) {} }
  const revoke = () => { if (!allowed()) { revoked = true; forget(); forgetConfirmed() } }
  window.addEventListener('CookiebotOnDecline', revoke)
  window.addEventListener('CookiebotOnAccept', revoke)

  // All confirmed registration surfaces use this same consent and delivery path.
  const deliver = (attempt, surface, onDone, deadline = 1200) => {
    let finished = false
    let redirectTimer
    let routeTimer
    const redirect = () => {
      if (finished) return
      finished = true
      window.clearTimeout(redirectTimer)
      window.clearTimeout(routeTimer)
      onDone()
    }
    if (!containerId ||
        !attempt || typeof attempt.id !== 'string' ||
        !/^[0-9a-f-]{36}$/i.test(attempt.id) || !Number.isFinite(attempt.started) ||
        Date.now() < attempt.started || Date.now() - attempt.started > 15 * 60 * 1000) {
      redirect()
      return
    }
    let evaluated = false
    const complete = () => {
      if (finished || evaluated) return
      if (revoked || !allowed()) { redirect(); return }
      // GTM's DK readiness tag can load after the native confirmation page.
      // Keep the consumed attempt only in this closure and wait within the
      // existing redirect deadline; never replay it after navigation.
      if (!routeReady()) {
        if (!routeTimer) routeTimer = window.setTimeout(() => {
          routeTimer = null
          complete()
        }, 25)
        return
      }
      evaluated = true
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'customer_club_signup',
        customer_club_popup_action: 'submit_success',
        customer_club_surface: surface,
        customer_club_event_id: attempt.id,
        ...(useGoogleCompletion ? { customer_club_delivery_callback: redirect } : {}),
        eventCallback: (completedContainerId) => {
          // Other containers can finish before our signup tag has run.
          // A GTM tag can finish while the Google event is still queued.
          // DE waits for Google's event_callback instead; the deadline below
          // still releases navigation when the tag is blocked or unavailable.
          if (!useGoogleCompletion && completedContainerId === containerId) redirect()
        },
        eventTimeout: 800
      })
    }
    // Do not block the customer's navigation if consent or GTM fails to initialise.
    redirectTimer = window.setTimeout(redirect, deadline)
    if (window.Cookiebot?.hasResponse) complete()
    else window.addEventListener('CookiebotOnConsentReady', complete, { once: true })
  }
  if (['kabooki.dk', 'kabooki.de'].includes(window.location.hostname)) {
    window.KabookiClubTracking = {
      begin(surface) {
        if (!['popup', 'wishlist'].includes(surface)) return null
        if (revoked || !routeReady() || !allowed() || !window.crypto?.randomUUID) return null
        const attempt = { id: window.crypto.randomUUID(), started: Date.now() }
        let consumed = false
        return {
          confirm(response, page, onDone) {
            if (consumed) return
            if (!response?.ok || !page?.querySelector('.user-area__created')) return
            const url = new URL(response.url, window.location.href)
            if (url.origin !== window.location.origin) return
            consumed = true
            deliver(attempt, surface, onDone)
          }
        }
      }
    }
  }
  // DE native confirmation redirects quickly. Transfer only a confirmed, fresh
  // attempt to the destination, then consume it before asynchronous delivery.
  // A direct visit, refresh or browser back must never create another signup.
  if (useGoogleCompletion && window.location.pathname === '/club-thank-you') {
    let confirmed
    try { confirmed = JSON.parse(window.sessionStorage.getItem(confirmedKey)) } catch (_) {}
    forgetConfirmed()
    if (confirmed && Number.isFinite(confirmed.confirmedAt) &&
        Date.now() >= confirmed.confirmedAt && Date.now() - confirmed.confirmedAt <= 60000) {
      deliver(confirmed, 'signup_page', () => {}, 10000)
    }
    return
  }
  if (!document.querySelector('.user-area__created')) {
    if (useGoogleCompletion) forgetConfirmed()
    return
  }
  const attempt = read()
  forget() // Consume before any asynchronous callback or duplicate initialisation.
  if (useGoogleCompletion) {
    forgetConfirmed()
    if (!revoked && (!window.Cookiebot?.hasResponse || allowed()) && attempt && typeof attempt.id === 'string' &&
        /^[0-9a-f-]{36}$/i.test(attempt.id) && Number.isFinite(attempt.started) &&
        Date.now() >= attempt.started && Date.now() - attempt.started <= 15 * 60 * 1000) {
      try {
        window.sessionStorage.setItem(confirmedKey, JSON.stringify({
          id: attempt.id, started: attempt.started, confirmedAt: Date.now()
        }))
      } catch (_) { /* No fallback send: avoid an uncertain delivery and replay. */ }
    }
    window.location.replace('/club-thank-you')
    return
  }
  deliver(attempt, 'signup_page', () => window.location.replace('/club-thank-you'))

})()

document.querySelectorAll('.js-user-auth-card').forEach((card) => {
  const tabs = Array.from(card.querySelectorAll('.js-user-auth-tab'))
  const panels = Array.from(card.querySelectorAll('[data-auth-panel-content]'))

  const showPanel = (name, focus = true) => {
    tabs.forEach((tab) => {
      const active = tab.dataset.authPanel === name
      tab.classList.toggle('is-active', active)
      tab.setAttribute('aria-selected', active ? 'true' : 'false')
    })
    panels.forEach((panel) => {
      const active = panel.dataset.authPanelContent === name
      panel.hidden = !active
      panel.classList.toggle('is-active', active)
      if (active && focus) panel.querySelector('input:not([type="hidden"])')?.focus()
    })
  }

  const showLinkedPanel = () => {
    if (window.location.hash === '#signup') {
      if (!window.KabookiGameSignup?.open()) showPanel('signup', false)
    }
    else if (window.location.hash === '#login') showPanel('login', false)
  }
  showLinkedPanel()
  window.addEventListener('hashchange', showLinkedPanel)

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => showPanel(tab.dataset.authPanel))
  })

  card.querySelectorAll('.js-user-auth-show-login').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      showPanel('login')
    })
  })

  card.querySelectorAll('.js-user-auth-show-signup').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      showPanel('signup')
    })
  })

  document.querySelectorAll('.editorial-text__actions a[href]').forEach((link) => {
    const target = new URL(link.href, window.location.origin)
    if (target.origin !== window.location.origin || target.pathname !== '/user-sign-up') return

    link.addEventListener('click', (event) => {
      event.preventDefault()
      showPanel('signup', false)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  })
})
